<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="486px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div class="set-level-box">
      <a-form
        :form="form"
        :hide-required-mark="true"
      >
        <template>
          <div>
            <a-form-item
              :label="`${levelMethodTit}：`"
              class="level-type"
            >
              <a-radio-group
                v-decorator="['type', { initialValue: itemData.fieldconfig.type.toString() || '1' }]"
                @change="changetype"
              >
                <a-radio value="1">
                  {{ $t('message["1657"]') }}
                </a-radio>
                <a-radio value="2">
                  {{ $t('message["1383"]') }}
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div>
            <a-form-item
              :label="`${levelNumber}：`"
            >
              <a-input-number
                v-decorator="['level', { rules: [{ required: true, message: noEmpty }], initialValue: itemData.fieldconfig.level || 5 }]"
                :min="2"
                :max="7"
                style="width:320px;"
                @change="changeLevel"
              />
            </a-form-item>
          </div>
          <div>
            <a-form-item
              :label="`${levelDescirpt}：`"
            >
              <a-checkbox
                :checked="!!itemData.fieldconfig.isexplain"
                @change="handleChange"
              >
                {{ $t('message["553"]') }}
              </a-checkbox>
            </a-form-item>
            <div class="level-info-box">
              <div
                v-for="(item, index) in letterArr.slice(0,itemData.fieldconfig.level)"
                :key="index"
                class="level-info"
              >
                <div class="clearfix">
                  <a-form-item
                    class="level-label"
                    :class="{'word-label': itemData.fieldconfig.type*1 === 1}"
                  >
                    <template>
                      <span
                        v-if="itemData.fieldconfig.type*1 === 1"
                        class="ant-form-text"
                      >
                        {{ item }}:
                      </span>
                      <a-rate
                        v-else
                        v-decorator="[`rate[${index}]`, {initialValue: (itemData.fieldconfig.level-index)}]"
                        allow-half
                        :count="itemData.fieldconfig.level-index"
                        disabled
                      />
                    </template>
                  </a-form-item>
                  <a-form-item>
                    <a-input
                      v-decorator="[`explain[${index}]`, { initialValue: itemData.fieldconfig.explain[index] || '' }]"
                      :placeholder="levelDescPlace"
                    />
                  </a-form-item>
                </div>
              </div>
            </div>
          </div>
        </template>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      letterArr: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
      newArr: []
    }
  },
  computed: {
    ...mapState('config/collect', ['datas']),
    isDatetime () {
      return this.itemData.fieldtype === 'datetime'
    },
    noEmpty () {
      return this.$t('message["67"]')
    },
    levelMethodTit () {
      return this.$t('message["294"]')
    },
    levelNumber () {
      return this.$t('message["295"]')
    },
    levelDescirpt () {
      return this.$t('message["296"]')
    },
    levelDescPlace () {
      return this.$t('message["769"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1021"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    handleChange (e) {
      this.itemData.fieldconfig.isexplain = e.target.checked ? 1 : 0
    },
    changeLevel (e) {
      this.itemData.fieldconfig.level = e
    },
    changetype (e) {
      this.itemData.fieldconfig.type = (e.target.value * 1)
    },
    formHandle () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.itemData.fieldconfig.type = values.type * 1
          this.itemData.fieldconfig.level = values.level
          this.itemData.fieldconfig.explain = values.explain
          this.isLimitDialogShow = false
        }
      })
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      // this.$set(this.itemData, {
      // options2: this.cloneData.options2, options: this.cloneData.options, fieldconfig: this.cloneData.fieldconfig })
      this.$set(this.itemData.fieldconfig, 'type', this.cloneData.fieldconfig.type)
      this.$set(this.itemData.fieldconfig, 'level', this.cloneData.fieldconfig.level)
      this.$set(this.itemData.fieldconfig, 'explain', this.cloneData.fieldconfig.explain)
      this.$set(this.itemData.fieldconfig, 'isexplain', this.cloneData.fieldconfig.isexplain)
    }
  }
}
</script>
<style lang="scss" scoped>
.set-level-box::v-deep {
  margin: 16px 0 16px 16px;
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .level-type {
    .ant-radio-wrapper {
      margin-right: 24px;
      span.ant-radio + * {
        padding-left: 4px;
        padding-right: 0;
      }
    }
  }
  .ant-row {
    padding-left: 85px;
    .ant-form-item-label {
      float: left;
      width: 85px;
      margin-left: -85px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }
  .level-info-box {
    margin-left: 85px;
      border: 1px solid #ebebeb;
      border-radius: 4px;
      padding: 10px;
      width: 320px;
      margin-top: -32px;
      .ant-row {
        padding-left: 0;
        margin-bottom: 4px;
        float: left;
        width: 50%;
        .ant-form-item-label {
          margin-left: 0;
        }
        .ant-form-text {
          display: inline-block;
        }
        .ant-input, .ant-input:focus {
          border:none;
          box-shadow:none;
          height: 20px;
          line-height: 20px;
          width: 170px;
        }
        .ant-form-item-control-wrapper {
          height: 20px;
          line-height: 20px;
          .ant-form-item-control {
            line-height: 20px;
          }
          .ant-rate {
            font-size: 12px;
            color: #f6a953;
          }
          .ant-rate-star {
            margin-right: 2px;
          }
        }
      }
      .level-label {
        width: 45%
      }
      .word-label{
        width: 8%;
      }
    }
}
</style>
